import chroma from 'chroma-js';

export function getContrastColor(color: string) {
  if (typeof color != 'string' && typeof window == 'undefined') {
    return color;
  }

  if (!color?.startsWith('#')) {
    return color;
  }

  return chroma(color).luminance() < 0.4 ? 'rgb(255, 255, 255)' : 'rgb(51, 51, 51)';
}
